import React, { Component } from 'react';
import { connect } from 'react-redux';
import SellPaymentsModalView from './SellPaymentsModal.view';


export class SellPaymentsModalContainer extends Component {

  constructor(props){
    super(props);
    this.closeSellPaymentsModal = this.closeSellPaymentsModal.bind(this);
  }

  componentDidMount() {
    this.getData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.filtersFormState !== nextProps.filtersFormState) {
      this.getData(nextProps);
    }
  }

  getData(props) {
    const { dispatch, trade, filtersFormState } = props;

    dispatch({
      type: 'FETCH_SELL_PAYMENTS',
      payload: {
        filters: {
          type: filtersFormState.data.type,
          sort: filtersFormState.data.sort,
        }
      }
    })
  }

  closeSellPaymentsModal() {
    const { dispatch } = this.props;

    dispatch({
      type: 'TOGGLE_SELL_PAYMENTS_MODAL',
      payload: {
        active: false,
      },
    });
  }

  render() {
    return (<SellPaymentsModalView
      {...this.props}
      {...this.state}
      closeSellPaymentsModal={this.closeSellPaymentsModal}
    />);
  }

}

function mapStateToProps(state) {
  const { payments, sellPaymentsModalActive, filtersFormState } = state.sellPaymentsPanel;
  return {
    payments,
    sellPaymentsModalActive,
    filtersFormState,
  };
}

export default connect(mapStateToProps)(SellPaymentsModalContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/SellPaymentsModal/SellPaymentsModal.container.js